var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg32Rename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3C19.4467 3.00367 22.7513 4.37436 25.1885 6.81152C27.6256 9.2487 28.9964 12.5533 29 16C29 18.5712 28.2371 21.0848 26.8086 23.2227C25.3801 25.3603 23.3499 27.0269 20.9746 28.0107C18.5993 28.9946 15.9855 29.2516 13.4639 28.75C10.9421 28.2484 8.62569 27.0104 6.80762 25.1924C4.98954 23.3743 3.75161 21.0579 3.25 18.5361C2.74841 16.0145 3.00542 13.4007 3.98926 11.0254C4.9732 8.64995 6.6395 6.61889 8.77734 5.19043C10.9152 3.76202 13.4289 3 16 3ZM19.7998 8.58691C19.4704 8.25765 18.9491 8.23645 18.5957 8.52441L18.5273 8.58594L10.3027 16.8115C10.0316 17.0827 9.85381 17.4334 9.7959 17.8125L9.32617 20.8896L9.30566 21.1113C9.27262 22.2133 10.2516 23.1121 11.377 22.9404L14.4531 22.4697C14.8321 22.4118 15.183 22.2339 15.4541 21.9629L23.6797 13.7383L23.7412 13.6709C24.0101 13.341 24.0102 12.864 23.7412 12.5342L23.6797 12.4658L19.7998 8.58691ZM18.8164 16.0557L14.1816 20.6904L11.1055 21.1611L11.5752 18.084L16.21 13.4482L18.8164 16.0557ZM21.7705 13.1025L20.0898 14.7822L17.4824 12.1758L19.1631 10.4951L21.7705 13.1025Z",
    fill: "#A4ACB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg32Rename);
export default __webpack_public_path__ + "static/media/32_Rename.14cab49c2b3c6b53c7c98f259e1498c0.svg";
export { ForwardRef as ReactComponent };